import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import SuperbetLobbyConponent from "../Components/SuperbetLobbyComponent";

interface SIL {
    atagParams: string | null,
    ticketOpenMode: string | null,
    mode?: string | null
    sourceParams: string | null,
}
const SuperbetLobby: FC <SIL> = ({atagParams, mode, sourceParams, ticketOpenMode}) => {
    const {getSuperbetsData} = useAction();
    const {superbetsData} = useTypedSelector((state) => state.superbetsReducer);

    useEffect(()=>{
        getSuperbetsData();
    }, [])
    return (
        <>
            {
                superbetsData.length > 0 ?
                    <SuperbetLobbyConponent data={superbetsData} ticketOpenMode={ticketOpenMode} sourceParams={sourceParams} atagParams={atagParams} mode={mode} />
                    : null
            }
        </>
    );

}

export default SuperbetLobby;
